module.exports = __webpack_public_path__ + "img/hovered-layer7.bced999b.png";